/**
 * @file
 * Content slider.
 */

(function (Drupal) {
  Drupal.behaviors.contentSlider = {
    attach: function () {
      var contentSliders = document.querySelectorAll(".js-content-slider");
      var that = this;

      for (var i = 0; i < contentSliders.length; i++) {
        that.initContentSlider(contentSliders[i]);
      }
    },
    initContentSlider: function (elem) {
      if (elem.classList.contains("is-initialized")) {
        return;
      }

      var options = {
        container: elem.querySelector(".js-content-slider-items"),
        items: 1,
        slideBy: 1,
        autoplay: false,
        mouseDrag: false,
        swipeAngle: false,
        nav: false,
        controlsContainer: elem.querySelector(".js-content-slider-controls"),
        navContainer: elem.querySelector(".js-content-slider-nav"),
        loop: true,
        rewind: true,
      };

      if (elem.classList.contains("has-multiple-pages")) {
        options.responsive = {
          670: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1100: {
            items: 4,
          },
        };
      }

      if (elem.classList.contains("has-nav")) {
        options.nav = true;
      }

      // eslint-disable-next-line no-undef
      tns(options);

      elem.classList.add("is-initialized");
    },
  };
})(Drupal);
